module.exports = __webpack_public_path__ + "cbe4a35efa11d5320b11394430e645f4.svg";